
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/tune-bot",
      function () {
        return require("private-next-pages/docs/tune-bot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/tune-bot"])
      });
    }
  